<template>
  <van-icon name="warning" @click="showTip"></van-icon>
</template>

<script>
  export default {
    props: {
      title: String,
      message: String
    },
    data() {
      return {}
    },
    methods: {
      showTip() {
        vtDialog.alert({
          title: this.title,
          message: this.message,
        }).then(() => {
          // on close
        })
      }
    }
  }
</script>

<style scoped>
</style>
